import React from "react";
import { useParams } from "react-router-dom";
import Dashboard from "../../Container";
import Create from "../Create";
import Feedback from "../feedback";
import Update from "../Update";

const Dashboards = () => {
  const { menu } = useParams();

  return (
    <Dashboard>
      {(menu === "create" && <Create />) || ""}
      {(menu === "update" && <Update />) || ""}
      {(menu === "feedback" && <Feedback />) || ""}
    </Dashboard>
  );
};

export default Dashboards;



// WEBPACK FOOTER //
// ./src/Pages/PagesWrapper/index.js